<div class="page-layout padding-large m-margin-none m-padding m-padding-top-largest">
	<div class="flex margin-bottom">
		<div class="flex-1 flex center">
			<h4>Search Photographers</h4>
		</div>
	</div>

	<div class="flex wrap gap">
		<div class="filter-chip" [ngClass]="!photographerFilters.textSearch ? '' : 'selected'">
			@if (photographerFilters.textSearch) {
				<div class="flex center hover" (click)="openStyleCodesFilter()">
					<b class="margin-right-smallest">Name or surname:</b>
					{{ photographerFilters.textSearch }}
				</div>

				<mat-icon class="hover" (click)="cleanFilter('textSearch')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openStyleCodesFilter()">
					Name or surname
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!photographerFilters.brands || !photographerFilters.brands.length ? '' : 'selected'">
			@if (photographerFilters.brands && photographerFilters.brands.length) {
				<div class="flex center hover" (click)="openBrandFilterModal()">
					<b class="margin-right-smallest">Brand:</b>

					@for (brand of photographerFilters.brands; track brand; let last = $last) {
						{{ brand.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('brands')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openBrandFilterModal()">
					Brand
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!photographerFilters.contractDate ? '' : 'selected'">
			@if (photographerFilters.contractDate) {
				<div class="flex center hover" (click)="openContractDateFilterModal()">
					<b class="margin-right-smallest">Contract Date:</b>

					{{ photographerFilters.contractDate.from | date: 'dd-MM-yyyy' }} - {{ photographerFilters.contractDate.to | date: 'dd-MM-yyyy' }}
				</div>
				<mat-icon (click)="cleanFilter('contractDate')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openContractDateFilterModal()">
					Contract Date
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!photographerFilters.statuses || !photographerFilters.statuses.length ? '' : 'selected'">
			@if (photographerFilters.statuses && photographerFilters.statuses.length) {
				<div class="flex center hover" (click)="openStatusFilterModal()">
					<b class="margin-right-smallest">Status:</b>

					@for (status of photographerFilters.statuses; track status; let last = $last) {
						{{ status.name }}
						@if (!last) {
							,
						}
					}
				</div>

				<mat-icon (click)="cleanFilter('statuses')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openStatusFilterModal()">
					Status
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>
	</div>

	<div class="margin-top-small">
		<div class="flex column end margin-bottom-small">
			<button [routerLink]="['/company/order-view/new/order-detail-info']" class="flex center" [disabled]="true">
				<mat-icon>add</mat-icon>
				Add photographer
			</button>
		</div>

		@if (photographers && photographers.items && photographers.items.length) {
			<bt-paginator [pageNumber]="photographers.currentPage" [pageSize]="photographers.size" [totalNumber]="photographers.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>

			<table class="desktop-only">
				<tr>
					<th>Id</th>
					<th>Name</th>
					<th>Hired from</th>
					<th>Hired to</th>
					<th>Brands</th>
					<th>Status</th>
					<th>Action</th>
				</tr>
				@for (item of photographers.items; track item) {
					<tr>
						<td>
							{{ item.id }}
						</td>
						<td>{{ item.fullName }}</td>
						<td>
							{{ item.hired && item.hired.from ? (item.hired.from | date: 'dd-MM-yyyy') : '-' }}
						</td>
						<td>
							{{ item.hired && item.hired.to ? (item.hired.to | date: 'dd-MM-yyyy') : '-' }}
						</td>

						<td>
							@for (brand of item.brands; track brand; let last = $last) {
								{{ brand.name }}
								@if (!last) {
									,
								}
							}
						</td>

						<td>
							@if (item.status.id == photographerStatus.DELETED) {
								<span class="radius bg-light-grey primary-dark padding-right-smallest padding-left-smallest">Deleted</span>
							} @else if (item.status.id == photographerStatus.ON_TRIAL) {
								<span class="radius bg-primary white padding-right-smallest padding-left-smallest">On trial</span>
							} @else if (item.status.id == photographerStatus.HIRED) {
								<span class="radius bg-primary white padding-right-smallest padding-left-smallest">Hired</span>
							} @else if (item.status.id == photographerStatus.REFUSED) {
								<span class="radius bg-orange red padding-right-smallest padding-left-smallest">Refused</span>
							} @else if (item.status.id == photographerStatus.REQUESTED) {
								<span class="radius bg-orange primary-dark padding-right-smallest padding-left-smallest">Requested</span>
							} @else if (item.status.id == photographerStatus.REJECTED) {
								<span class="radius bg-orange red padding-right-smallest padding-left-smallest">Rejected</span>
							} @else if (item.status.id == photographerStatus.DISMISSED) {
								<span class="radius bg-orange grey padding-right-smallest padding-left-smallest">Dismissed</span>
							}
						</td>
						<td>
							<div class="flex center full-width">
								<a [routerLink]="['/company/order-view/' + item.id + '/photographer-detail']" class="hover flex center primary disabled">
									<mat-icon class="small margin-right-smallest">visibility</mat-icon>
									Open
								</a>
								<!-- @if (item.status.id == orderStatus.Draft) {
									<span class="margin-left-small hover flex center red" (click)="removeOrder(item)">
										<mat-icon class="small">close</mat-icon>
										Remove
									</span>
								} -->
							</div>
						</td>
					</tr>
				}
			</table>

			<div class="mobile-only flex column gap">
				@for (item of photographers.items; track item) {
					<div class="border radius padding margin-bottom-small">
						<div class="flex center gap margin-bottom-small">
							<span class="status-chip">
								{{ item.status.name }}
							</span>
							<span class="grey">{{ item.hired && item.hired.from ? (item.hired.from | date: 'dd-MM-yyyy') : '-' }}</span>
						</div>
						<div class="flex column gap margin-bottom-small">
							<div>
								<b>ID:</b>
								{{ item.id }}
							</div>
							<div>
								<b>Name:</b>
								{{ item.fullName }}
							</div>
							@if (item.hired && item.hired.to) {
								<div>
									<b>Hired to:</b>
									{{ item.hired.to | date: 'dd-MM-yyyy' }}
								</div>
							}
						</div>
						<div class="flex column end gap">
							<div class="flex center">
								<a class="hover flex center primary" [routerLink]="['/company/order-view/' + item.id + '/photographer-detail']">
									<mat-icon class="small margin-right-smallest">visibility</mat-icon>
									Open
								</a>
							</div>
						</div>
					</div>
				}
			</div>

			<bt-paginator [pageNumber]="photographers.currentPage" [pageSize]="photographers.size" [totalNumber]="photographers.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>
		}

		@if (photographers.items.length == 0 && !loading) {
			<div class="flex center bg-light-grey padding-largest justify-center">
				<div class="flex column center gap">
					<i class="fa fa-search fa-2xl margin-bottom grey"></i>
					<span>No data found</span>
				</div>
				
			</div>
		}
	</div>
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
